import React, { Component } from 'react';
// redux
import { connect } from 'react-redux';
import { validateToken } from '../../../redux/reducers/auth';
// utils
import get from 'lodash.get';
import { toast } from 'react-toastify';
import queryString from 'query-string';
import { setAuthData } from '../../../utils/authData';
import { toastResponseErrors } from '../../../utils/response';

class SignUpConfirmation extends Component {
  componentDidMount() {
    const {
      location: { search },
      validateToken,
      history
    } = this.props;
    const query = queryString.parse(search);
    if (query['account_confirmation_success']) {
      setAuthData({
        uid: query.uid,
        'access-token': query.token,
        expiry: query.expiry,
        client: query.client_id,
        'token-type': 'Bearer'
      });
      validateToken()
        .then(response => {
          const role = get(response, 'value.resource.role') || 'client';
          if (role === 'client') {
            toast.info(
              'Thank you for joining us! Please finish the registration process.'
            );
            history.replace('/signup/username');
          }
          if (role === 'support') {
            toast.info("Thank you for join us! You're registered as support.");
            history.replace('/profile');
          }
        })
        .catch(toastResponseErrors);
    } else {
      history.replace('/signup');
    }
  }

  render() {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          alignItems: 'center',
          height: '50vh',
          fontSize: '18px',
          letterSpacing: '12px',
          color: '#216ba5',
          opacity: '0.75'
        }}
      >
        WAIT A SECOND...
      </div>
    );
  }
}

export default connect(
  null,
  { validateToken }
)(SignUpConfirmation);



// WEBPACK FOOTER //
// ./src/containers/SignUp/components/SignUpConfirmation.js